module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_NL-fd9a0f01bc0121c946bea581627a0507.svg";